"use client";

import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/lib/query-keys";
import { getValidatorApplicationStatisticsAction } from "@/resources/actions/user.actions";

export function useValidatorStatistics(walletAddress?: string) {
  return useQuery({
    queryKey: queryKeys.validators.applications.statistics(walletAddress ?? ""),
    queryFn: async () => {
      const result = await getValidatorApplicationStatisticsAction({
        walletAddress: walletAddress ?? "",
      });
      if (result.error) throw new Error(result.error);
      return result.data;
    },
    enabled: !!walletAddress,
    staleTime: 1000 * 60 * 1, // 1 minute
  });
}
